module.exports = __webpack_public_path__ + "static/media/362.fe6cd048.svg";